import { cn } from "../../../lib/utils";

interface Section {
  id: string;
  label: string;
  visible: boolean;
}

interface SectionNavProps {
  sections: Section[];
  activeSection: string;
  onNavigate?: (sectionId: string) => void;
}

export function SectionNav({ sections, activeSection, onNavigate }: SectionNavProps): React.ReactElement {
  const visibleSections = sections.filter((s) => s.visible);

  return (
    <nav className="space-y-0.5">
      <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-2">Sections</p>
      {visibleSections.map((section) => (
        <button
          key={section.id}
          type="button"
          onClick={() => onNavigate?.(section.id)}
          className={cn(
            "block w-full text-left rounded-r-md px-3 py-1.5 text-sm transition-all",
            activeSection === section.id
              ? "border-l-2 border-primary bg-accent text-accent-foreground font-medium"
              : "border-l-2 border-transparent text-muted-foreground hover:text-foreground hover:bg-accent/50",
          )}
        >
          {section.label}
        </button>
      ))}
    </nav>
  );
}
